<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div>
      <div class="row">
        <div class="col-md-12 component-title-row">
          <h3><i class="fa fa-fw fa-shopping-cart"></i> {{ _('Orders') }}</h3>
          <div class="component-title-buttons">
            <div v-if="isFloatingReceiptAvailable">
              <button class="newSelector btn btn-success addbutton" type="button" v-on:click.stop="newOrder"><i class="fa fa-fw fa-plus"></i><span class="hidden-xs"> {{ _('Create new...') }}</span></button>
            </div>
          </div>
        </div>
      </div>
      <div class="list-filter-row">
        <div class="list-filter-col filtercol">
          <div class="form-group">
            <div class="input-group">
              <input class="form-control" id="searchField" type="text" v-model="search" :placeholder="_('Keyword search')" />
              <span class="input-group-btn">
                <button type="button" :class="'btn btn-info hidden-col-sm hidden-col-md hidden-col-lg' + (listFilterVisible ? ' active' : '')" :title="(listFilterVisible ? 'Piilota rajaimet' : 'Näytä rajaimet')" @click="listFilterVisible = !listFilterVisible"><i :class="'fa fa-fw ' + (listFilterVisible ? 'fa-caret-up' : 'fa-sliders')"></i></button>
                <button type="button" :class="'hidden-col-xs btn btn-success'" :title="_('Search')"><i class="fa fa-fw fa-search"></i></button>
              </span>
            </div>
          </div>
        </div>
        <template v-if="listFilterVisible">
          <div class="list-filter-col filtercol">
            <div class="form-group">
              <div class="input-group">
                <div class="input-group-addon">{{ _('Display') }}</div>
                <select class="form-control" id="orderTypeFilter" v-model="type">
                  <option value="all">{{ _('Select...') }}</option>
                  <option value="notpaid">{{ _('Unpaid items') }}</option>
                  <option value="paid">{{ _('Paid items') }}</option>
                  <option value="refunded">{{ _('Refunded items') }}</option>
                  <option value="notprocessed">{{ _('Unprocessed items') }}</option>
                  <option value="processed">{{ _('Processed items') }}</option>
                  <option value="paidnotprocessed">{{ _('Paid and unprocessed') }}</option>
                  <option disabled="disabled">-</option>
                  <option v-if="isFeatureEnabled('paymentplans')" value="paymentplans">{{ _('Orders with payment plans') }}</option>
                  <option v-if="isFeatureEnabled('paymentplans')" value="subscriptions">{{ _('Subscription orders') }}</option>
                  <option value="withmore">{{ _('Orders with additional info') }}</option>
                  <option value="withrequests">{{ _('Orders with pending requests') }}</option>
                  <option value="open">{{ _('Open orders') }}</option>
                  <option value="confirmed">{{ _('Confirmed orders') }}</option>
                  <option value="grouped">{{ _('Consolidated orders') }}</option>
                  <option value="consolidated">{{ _('Shared orders') }}</option>
                  <option value="archived">{{ _('Archived orders') }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="list-filter-col filtercol">
            <div class="form-group">
              <div class="input-group">
                <div class="input-group-addon">{{ _('Filter') }}</div>
                <select class="form-control" id="orderRangeFilter" v-model="range">
                  <option class="rangeOption" value="all">{{ _('No filter') }}</option>
                  <optgroup :label="_('By tag')" v-if="tags && tags.length">
                    <option class="tagOption" :value="'tag-' + tag.id" v-for="tag in tags">{{ tag.title }}</option>
                  </optgroup>
                  <optgroup :label="_('By product admin tag')" v-if="productTags && productTags.length">
                    <option class="tagOption" :value="'admintag-' + tag.id" v-for="tag in productTags">{{ tag.title }}</option>
                  </optgroup>
                  <optgroup :label="_('By POS')" v-if="poses && poses.length">
                    <option class="posOption" :value="'pos-' + pos.id" v-for="pos in poses">{{ pos.name }}</option>
                    <option class="posOption" value="allpos">{{ _('All POS transactions') }}</option>
                    <option class="posOption" value="nopos">{{ _('No POS transactions') }}</option>
                  </optgroup>
                </select>
              </div>
            </div>
          </div>
          <div class="list-filter-col button-col filtercol">
            <select class="form-control" id="dateRangeSelectFilter" v-model="dateRangeSelectFilter">
              <option class="rangeOption" value="">{{ _('Select date range') }}</option>
              <optgroup :label="_('By time range')">
                <option class="rangeOption" value="lastweek">{{ _('Last week') }}</option>
                <option class="rangeOption" value="lastmonth">{{ _('Last month') }}</option>
                <option class="rangeOption" value="lastyear">{{ _('Last year') }}</option>
                <option class="rangeOption" value="exact">{{ _('Select exact date range') }}</option>
                <option class="rangeOption" value="all">{{ _('All orders') }}</option>
              </optgroup>
            </select>
          </div>
          <div class="list-filter-col" v-if="showExactRange">
            <div class="rangeFields">
              <div class="form-inline">
                <div class="form-group">
                  <DatePicker v-model="dateStart" :max-date="dateEnd" :shortLocale="shortLocale" :staticInput="true" :placeholder="_('Select start date')"></DatePicker>
                </div>
                <label for="endDate"> - </label>
                <div class="form-group">
                  <DatePicker v-model="dateEnd" :min-date="dateStart" :shortLocale="shortLocale" :staticInput="true" :placeholder="_('Select end date')"></DatePicker>
                </div>
              </div>
            </div>
          </div>
          <div class="list-filter-col button-col filtercol">
            <button :class="'btn btn-default' + (tableOptions.selectable ? ' active' : '')" type="button" v-on:click="toggleMultiSelect"><template v-if="tableOptions.selectable"><i class="fa fa-fw fa-window-close"></i><span class="hidden-xs"> {{ _('Select') }}</span></template><template v-else><i class="fa fa-fw fa-check-square"></i> <span class="hidden-xs"> {{ _('Select') }}</span></template></button>
          </div>
        </template>
      </div>
      <div class="list-filter-row select-options" v-if="tableOptions.selectable">
        <div class="list-filter-col">
          <div class="form-inline">
            <Dropdown buttonClass="btn-default">
              <template #trigger>
                {{ _('Set...') }} &nbsp;<span class="caret"></span>
              </template>
              <li><a href="javascript:;" v-on:click="setSelectedAsProcessed">{{ _('As processed') }}</a></li>
              <li><a href="javascript:;" v-on:click="setSelectedAsUnProcessed">{{ _('As unprocessed') }}</a></li>
            </Dropdown>
            <button class="btn btn-info" type="button" v-on:click="consolidateSelected('combine')" :disabled="!canConsolidate"><i class="fa fa-fw fa-folder-open hidden-xs"></i> {{ _('Consolidate orders') }}</button>
            <button class="btn btn-info" type="button" v-on:click="consolidateSelectedAsRetainer" :disabled="!canConsolidateAsRetainer"><i class="fa fa-fw fa-minus-square hidden-xs"></i> {{ _('Process as retainer') }}</button>
            <button class="btn btn-danger" type="button" v-on:click="removeSelectedDialog" :disabled="!canDelete"><i class="fa fa-fw fa-trash"></i><span class="hidden-xs">{{ _('Delete') }}</span></button>
            <button class="btn btn-warning" type="button" v-on:click="archiveSelected" :disabled="!canArchive"><i class="fa fa-fw fa-ban"></i><span class="hidden-xs">{{ _('verb|Archive') }}</span></button>
            <button class="btn btn-success" type="button" v-on:click="downloadXlsx"><i class="fa fa-fw fa-download"></i><span class="hidden-xs">{{ _('Download Excel file') }}</span></button>
          </div>
        </div>
      </div>
      <Datatable :url="ordersUrl" :sort="sort" :search="search" :type-filter="type" :tag-filter="tag" :pos-filter="pos" :order-date-filter="dateRangeFilter" :options="tableOptions" ref="datatable" v-on:data="tableEvent" v-on:selection="rowsSelected" :locale="locale" />
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import { DateTime } from 'luxon'
import components from '~/lib/components'
import formatters from '~/lib/formatters'
import { Datatable } from '#components'

export default defineNuxtComponent({
  data () {
    let $this = this
    const _ = useNuxtApp().$translate
    return {
      orders: [],
      selectedOrders: [],
      showExactRange: false,
      dateStart: false,
      dateEnd: false,
      search: '',
      type: 'all',
      range: 'all',
      dateRangeValue: '',
      tags: [],
      productTags: [],
      poses: [],
      removeReservations: false,
      sort: [{
        column: 'id',
        dir: 'desc'
      }],
      tableOptions: {
        dataTree: true,
        selectable: false,
        parentType: 'consolidated',
        parentField: 'consolidate',
        rowFormatter: this.orderRowFormatter(),
        responsiveLayoutCollapseFormatter: this.collapseFormatter(),
        columns: [
          {
            title: _('No.'),
            field: 'id',
            width: 100,
            responsive: 0,
            // headerMenu: this.headerMenu('tableOptions') // This doesn't remember the settings with persistence due to responsivelayout hiding columns willy-nilly
          },
          {
            title: _('Customer name'),
            field: 'name',
            widthGrow: 4,
            formatter: this.orderCustomerFormatter(),
            responsive: 0,
          },
          {
            title: _('Total'),
            field: 'totalWithDelivery',
            widthGrow: 2,
            formatter: this.numberFormatter(),
            hozAlign: 'right'
          },
          {
            title: _('Status'),
            field: 'paid',
            width: 130,
            formatter: this.orderPaidFormatter(),
          },
          {
            title: _('Order date'),
            field: 'orderdate',
            widthGrow: 2,
            formatter: this.dateAndTimeFormatter()
          },
          {
            title: _('Processed'),
            field: 'processed',
            width: 110,
            formatter: this.processedFormatter(),
          },
          {
            title: _('Delivery method'),
            field: 'delivery',
            widthGrow: 2,
            formatter: this.deliveryMethodFormatter(),
          },
          {
            title: _('Source channel'),
            field: 'origin',
            widthGrow: 2,
            formatter: this.sourceChannelListFormatter()
          },
        ],
        initialSort: [{
          column: 'id',
          dir: 'desc'
        }],
        rowClick (e, row) {
          if (!$this.tableOptions.selectable) {
            $this.editRow(row)
          }
        }
      }
    }
  },
  mixins: [components, formatters],
  computed: {
    ordersUrl () {
      return this.baseDomain + this.shopId + '/orders.json?apikey=' + this.apiKey + '&rawformat=true'
    },
    totalBillable () {
      return this.selectedOrders.filter(o => parseInt(o.confirmed) === 1 || o.payment === 'open').length
    },
    totalNotBillable () {
      return this.selectedOrders.length - this.totalBillable
    },
    dateRangeSelectFilter: {
      get () {
        if(this.showExactRange) {
          return 'exact'
        }
        if(this.dateRange === '') {
          return ''
        }
        if (this.dateStart && this.dateEnd) {
          return DateTime.fromJSDate(this.dateStart, { zone: this.timezone }).toFormat('d.M.yyyy') + '-' + DateTime.fromJSDate(this.dateEnd, { zone: this.timezone }).toFormat('d.M.yyyy')
        }
        return this.dateRange
      },
      set (newValue) {
        if (!newValue || !newValue.match || !newValue.match('-')) {
          this.showExactRange = false
          this.dateStart = false
          this.dateEnd = false
          this.dateRange = newValue
          return
        }
        this.setExactRangeFromFilter(newValue)
      }
    },
    dateRangeFilter: {
      get () {
        if (this.dateStart && this.dateEnd) {
          return DateTime.fromJSDate(this.dateStart, { zone: this.timezone }).toFormat('d.M.yyyy') + '-' + DateTime.fromJSDate(this.dateEnd, { zone: this.timezone }).toFormat('d.M.yyyy')
        }
        return this.dateRange
      },
      set (newValue) {
        if (!newValue || !newValue.match || !newValue.match('-')) {
          this.showExactRange = false
          this.dateStart = false
          this.dateEnd = false
          this.dateRange = newValue
          return
        }
        this.setExactRangeFromFilter(newValue)
      }
    },
    tag: {
      get () {
        if (this.range && this.range.match(/(tag|admintag)-/)) {
          const tArr = this.range.split('-')
          return tArr[1]
        }
        return ''
      },
      set (newValue) {
        if (newValue) {
          if (this.tags.findIndex(t => parseInt(t.id, 10) === parseInt(newValue, 10)) !== -1) {
            this.range = 'tag-' + newValue
          } else {
            this.range = 'admintag-' + newValue
          }
        }
      }
    },
    pos: {
      get () {
        if (this.range && this.range.match(/pos-/)) {
          const pArr = this.range.split('-')
          return pArr[1]
        }
        if (this.range === 'allpos' || this.range === 'nopos') {
          return this.range
        }
        return ''
      },
      set (newValue) {
        if (newValue) {
          if (newValue === 'allpos' || newValue === 'nopos') {
            this.range = newValue
          } else {
            this.range = 'pos-' + newValue
          }
        }
      }
    },
    dateRange: {
      get () {
        switch (this.dateRangeValue) {
          case 'lastweek':
          case 'lastmonth':
          case 'lastyear':
          case 'exact':
            return this.dateRangeValue
        }
        return ''
      },
      set (newValue) {
        switch (newValue) {
          case 'lastweek':
          case 'lastmonth':
          case 'lastyear':
            this.dateRangeValue = newValue
            break
          case 'exact':
            if(!this.showExactRange) {
              this.showExactRange = true
            }
            this.dateRangeValue = newValue
          case '':
          case 'all':
            this.dateRangeValue = ''
            break
        }
      }
    },
    canSet () {
      return this.selectedOrders && this.selectedOrders.length > 0
    },
    canDelete () {
      return this.selectedOrders && this.selectedOrders.length > 0 && !this.selectedOrders.some(o => parseInt(o.paid))
    },
    canArchive () {
      return this.selectedOrders && this.selectedOrders.length > 0 && !this.selectedOrders.some(o => parseInt(o.archived))
    },
    canConsolidate () {
      return this.totalBillable > 0 && this.totalNotBillable === 0
    },
    canConsolidateAsRetainer () {
      return this.selectedOrders && this.selectedOrders.length && this.totalNotBillable === this.selectedOrders.length
    },
    hasSelection () {
      return this.selectedOrders && this.selectedOrders.length > 0
    }
  },
  methods: {
    downloadXlsx () {
      const filters = []
      if (this.hasSelection) {
        filters.push({ field: 'search', type: 'like', value: this.selectedOrders.map(o => o.id).join(',') })
      } else {
        if (this.search) {
          filters.push({ field: 'search', type: 'like', value: this.search })
        }
        if (this.type) {
          filters.push({ field: 'type', type: '=', value: this.type })
        }
        if (this.tag) {
          filters.push({ field: 'tag', type: '=', value: this.tag })
        }
        if (this.pos) {
          filters.push({ field: 'pos_name', type: '=', value: this.pos })
        }
        if (this.dateRangeFilter) {
          filters.push({ field: 'orderdate', type: '=', value: this.dateRangeFilter })
        }
      }
      let filterStr = ''
      if (filters.length) {
        filterStr = '&filters[]=' + filters.map(f => JSON.stringify(f)).join('&filters[]=')
      }
      window.open(this.baseDomain + this.shopId + '/orders.xlsx?apikey=' + this.apiKey + filterStr)
    },
    rowsSelected (data) {
      this.selectedOrders = data
    },
    setSelectedAsProcessed() {
      this.setSelected({ processed: 1, paymentdate: 'ignore' })
    },
    setSelectedAsUnProcessed() {
      this.setSelected({ processed: 0, paymentdate: 'ignore' })
    },
    setSelected(data) {
      const ids = this.selectedOrders.map(o => o.id)
      ids.forEach(async (id) => {
        const d = Object.assign({}, data)
        d.id = id
        try {
          await axios.put(this.baseDomain + this.shopId + '/orders/' + id + '.json?apikey=' + this.apiKey, d)
        } catch(e) {
          this.showError(e)
        }
      })
      this.selectedOrders = []
      this.tableOptions.selectable = false
    },
    consolidateSelectedAsRetainer() {
      this.removeReservations = false
      this.showDialog({
        title: this._('Remove resource reservations from original order?'),
        text: this._('Remove resource reservations from original order?'),
        width: 800,
        buttons: [
          {
            title: this._('No'),
            class: 'danger',
            icon: 'ban',
            handler: () => {
              this.consolidateSelected('combineasretainer')
            }
          },
          {
            title: this._('Yes'),
            class: 'success',
            icon: 'check',
            handler: () => {
              this.removeReservations = true
              this.consolidateSelected('combineasretainer')
            }
          }
        ]
      })
    },
    async consolidateSelected(mode, customerId, billingCustomerId) {
      let response
      const ids = this.selectedOrders.map(o => o.id)
      if (!mode) {
        mode = 'combine'
      }
      if (!customerId && !billingCustomerId) {
        try {
          response = await axios.post(this.baseDomain + this.shopId + '/orders.json?combinecheck=' + ids.join(',') + '&apikey=' + this.apiKey)
        } catch(e) {
          this.showError(e)
          return
        }
        if (response.data.status === 'conflict') {
          this.combineConflictDialog(mode, response.data)
          return
        }
      }
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/orders.json?' + mode + '=' + ids.join(',') + '&version=' + this.version + (customerId ? '&customer=' + customerId : '') + (billingCustomerId ? '&billingcustomer=' + billingCustomerId : '') + '&removereservations=' + this.removeReservations + '&apikey=' + this.apiKey)
      } catch(e) {
        this.showError(e)
        return
      }
      this.selectedOrders = []
      this.tableOptions.selectable = false
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'OrderDetails',
        title: this._('Order') + ' ' + response.data,
        width: 6,
        data: {
          orderId: response.data
        }
      })
    },
    combineConflictDialog(mode, conflict) {
      this.showDialog({
        title: this._('The selected orders have conflicting customer data'),
        text: this._('Please select a customer and a billing customer to use in the consolidated order, or leave the fields unselected to choose them later.'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'ban',
            handler: () => {}
          },
          {
            title: this._('Continue'),
            class: 'success',
            icon: 'check',
            handler: (data) => {
              this.consolidateSelected(mode, data.customer, data.billingCustomer)
            }
          }
        ],
        fields: [
          {
            title: this._('Customer'),
            type: 'select',
            name: 'customer',
            options: [{ name: this._('Not selected'), value: 0 }, ...conflict.customers.map(c => { return { name: c.name, value: c.id } })]
          },
          {
            title: this._('Billing Customer'),
            type: 'select',
            name: 'billingCustomer',
            options: [{ name: this._('Not selected'), value: 0}, ...conflict.billingCustomers.map(c => { return { name: c.company, value: c.id } })]
          },
        ]
      })
    },
    removeSelectedDialog () {
      this.showDialog({
        title: this._('Are you sure? Selected orders will be deleted permanently.'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'ban',
            handler: () => {}
          },
          {
            title: this._('Delete'),
            class: 'danger',
            icon: 'trash',
            handler: this.removeSelected
          }
        ]
      })
    },
    removeSelected () {
      for (let i = 0; i < this.selectedOrders.length; i++) {
        let id = this.selectedOrders[i].id
        this.removeOrder(id)
      }
      this.selectedOrders = []
      this.tableOptions.selectable = false
    },
    async removeOrder (id) {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/orders/' + id + '.json?apikey=' + this.apiKey)
      } catch(e) {
        // We can fail this silently, if no order is found, then it doesn't need to be deleted
        return
      }
      try {
        await axios.delete(this.baseDomain + this.shopId + '/orders/' + id + '.json?apikey=' + this.apiKey)
      } catch(e) {
        return this.showError(e)
      }
    },
    archiveSelectedDialog () {
      this.showDialog({
        title: this._('Are you sure you want to archive the selected orders?'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'ban',
            handler: () => {}
          },
          {
            title: this._('Archive and remove reservations'),
            class: 'danger',
            icon: 'trash',
            handler: () => {
              this.archiveSelected(true)
            }
          },
          {
            title: this._('verb|Archive'),
            class: 'warning',
            icon: 'ban',
            handler: this.archiveSelected
          }
        ]
      })
    },
    archiveSelected (removeReservations = false) {
      for (let i = 0; i < this.selectedOrders.length; i++) {
        let id = this.selectedOrders[i].id
        this.archiveOrder(id, removeReservations)
      }
      this.selectedOrders = []
      this.tableOptions.selectable = false
      this.reload()
    },
    async archiveOrder (id, removeReservations = false) {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/orders/' + id + '.json?apikey=' + this.apiKey)
      } catch(e) {
        // We can fail this silently, if no order is found, then it doesn't need to be archived
        return
      }
      try {
        await axios.patch(this.baseDomain + this.shopId + '/orders/' + id + '.json?apikey=' + this.apiKey, { id: id, archived: 1, removereservations: removeReservations ? 1 : 0 })
      } catch(e) {
        return this.showError(e)
      }
    },
    editRow (row) {
      const id = row.getCell('id').getValue()
      let name = row.getCell('name').getValue()
      if (!name) {
        const d = row._row.data
        if (d.pos_name) {
          name = d.pos_name
        } else {
          name = this._('Transaction incomplete')
        }
      }
      this.editOrder(id, name)
    },
    editOrder (id, name, skipState) {
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'OrderDetails',
        title: this._('Order') + ' ' + id + (name ? ': ' + name : ''),
        width: 6,
        data: {
          orderId: id
        },
        skipState
      })
    },
    newOrder () {
      this.EventBus.$emit('showFloatingReceipt')
    },
    reload (message) {
      if (this.$refs && this.$refs.datatable && !this.tableOptions.selectable) {
        this.$refs.datatable.reload(false, message)
      }
    },
    async loadTags () {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/tags.json?type=order&apikey=' + this.apiKey)
      } catch(e) {
        this.showError(e)
        return
      }
      this.tags = response.data.sort((a, b) => a.title > b.title ? 1 : -1)
    },
    async loadProductTags () {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/tags.json?type=admin&apikey=' + this.apiKey)
      } catch(e) {
        this.showError(e)
        return
      }
      this.productTags = response.data.sort((a, b) => a.title > b.title ? 1 : -1)
    },
    async loadPoses () {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/' + this.locale + '/pos.json?version=' + this.locale + '&iSortCol_0=1&sSortDir_0=asc&iSortingCols=1&apikey=' + this.apiKey)
      } catch(e) {
        this.showError(e)
        return
      }
      this.poses = response.data.sort((a, b) => a.name > b.name ? 1 : -1)
    },
    selectRange () {
      this.showExactRange = true
    },
    unselectRange () {
      this.showExactRange = this.dateStart = this.dateEnd = false
    },
    inputDateStart (newValue) {
      this.dateStart = newValue
    },
    inputDateEnd (newValue) {
      this.dateEnd = newValue
    }
  },
  components: {
    Datatable
  },
  watch: {
    type (newValue, oldValue) {
      if (newValue === 'consolidated') {
        this.EventBus.$emit('showComponent', {
          shopId: this.shopId,
          component: 'ConsolidatedOrderList',
          title: this._('Shared orders')
        })
        this.type = oldValue
      }
    },
    listFilterVisible () {
      this.$refs.datatable.resize()
    }
  },
  mounted () {
    this.loadTags()
    this.loadProductTags()
    this.loadPoses()
    if(!this.events) {
      let events = {}
      // Removed debounce since the reloader now (usually) only reloads a single order
      // If we have a debounce, we might not reload all orders when setting multiple orders as processed/unprocessed
      events['orderUpdate'] = (message) => {
        this.reload(message)
      }
      /*
      events['orderUpdate'] = debounce((message) => {
        return this.reload(message)
      }, 200)
      */
      events['restoreDetails'] = (message) => {
        if (message.shopId !== this.shopId) {
          return
        }
        switch(message.component) {
          case 'OrderDetails':
            this.editOrder(message.data.orderId, null, true)
            break
        }
      }
      events['setOrderListParams'] = (message) => {
        if (message) {
          if (message.type) {
            this.type = message.type
          }
        }
      }
      this.events = events
    }
    this.enableEventBus()
  }
})
</script>